<div class="kyc-container" *ngIf="loaded">
  <!-- Container baseado no estado atual -->
  <div [ngSwitch]="currentState">
    

    
    <!-- Estado: DONE - Sucesso (transitório) -->
    <ng-container *ngSwitchCase="'DONE'">
      <div class="kyc-success">
        <div class="success-icon">
          <mat-icon>check_circle</mat-icon>
        </div>
        <div class="success-content">
          <h2>{{ "Verification Complete!" | translate }}</h2>
          <p>{{ "identityVerified" | translate }}</p>
        </div>
      </div>
    </ng-container>
    
    <!-- Estado: FAILED - sempre renderiza o base-kyc-provider (app-document-kyc-upload-modal) -->
    <ng-container *ngSwitchCase="'FAILED'">
      <div class="kyc-failed">
        <div class="provider-container">
          <app-document-kyc-upload-modal (completed)="onComplete()"></app-document-kyc-upload-modal>
        </div>
      </div>
    </ng-container>
    
    <!-- Estado: PENDING - Aguardando ação do usuário -->
    <ng-container *ngSwitchCase="'PENDING'">
      <div class="kyc-pending">
        <!-- Provider de KYC -->
        <div class="provider-container" *ngIf="showProvider">
          <ng-container [ngSwitch]="action.config.provider">
            <ng-container *ngSwitchCase="'textract'">
              <app-textract-kyc-provider
                (completed)="onComplete()"
              ></app-textract-kyc-provider>
            </ng-container>
            <ng-container *ngSwitchCase="'thirdfort'">
              <app-veriff-lite-kyc-provider
                (completed)="onComplete()"
              ></app-veriff-lite-kyc-provider>
            </ng-container>
            <ng-container *ngSwitchCase="'veriff'">
              <app-veriff-kyc-provider
                (completed)="onComplete()"
              ></app-veriff-kyc-provider>
            </ng-container>
            <ng-container *ngSwitchCase="'verifflite'">
              <app-veriff-lite-kyc-provider
                (completed)="onComplete()"
              ></app-veriff-lite-kyc-provider>
            </ng-container>
            <ng-container *ngSwitchCase="'somoskyc_v1'">
              <app-somos-kyc-v1-provider
                (completed)="onComplete()"
              ></app-somos-kyc-v1-provider>
            </ng-container>
            <ng-container *ngSwitchDefault>
              <app-document-kyc-upload-modal
                (completed)="onComplete()"
              ></app-document-kyc-upload-modal>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </ng-container>
    
  </div>
</div>
